import ChallengeEngine from "./ChallengeEngine";
import "./ChallengeEnginePanel.css";

type ChallengeEnginePanelProps = {
  title: string;
  description: string;
  mode: "admin" | "ranking";
  challengeType?: "challenge" | "super8" | "poco" | "tournament";
};

export default function ChallengeEnginePanel({
  title,
  description,
  mode,
  challengeType = "challenge",
}: ChallengeEnginePanelProps) {
  return (
    <>
      <div className="page-header">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="challenge-wrapper">
        <ChallengeEngine mode={mode} challengeType={challengeType} />
      </div>
    </>
  );
}
